<div *ngIf="isCompanyMenuAvailable">
  <div class="button" (click)="toggleMenu()">
    <svg-icon [src]="logo" svgClass="logo opacity_button"></svg-icon>
    <nb-icon class="logo__arrow" icon="arrow-ios-downward-outline"></nb-icon>
  </div>

  <app-credits-bar
    *ngIf="credits?.enabled"
    class="opacity_button"
    [credits]="credits"
    (click)="toggleCreditsRequestDropdown()"
  ></app-credits-bar>
</div>

<div *ngIf="!isCompanyMenuAvailable">
  <svg-icon [src]="logo" svgClass="logo"></svg-icon>
  <app-credits-bar
    *ngIf="credits?.enabled"
    class="opacity_button"
    [credits]="credits"
    (click)="toggleCreditsRequestDropdown()"
  ></app-credits-bar>
</div>
